// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2T8ts","range":"MonthRangeSwitch_range__3sL92","disabled":"MonthRangeSwitch_disabled__10TR2"};